import { HttpInterceptorFn } from '@angular/common/http';

export const authInterceptorInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem('token'); // Get the JWT token from your service
  if (token) {
      const req2 = req.clone({
          setHeaders: {
              Authorization: `Bearer ${token}`
          }
      });
      return next(req2);
  }
  return next(req);
};
